<ef-time-card-documentation-presenter
    [process]="process$ | async"
    [includeClassify]="includeClassify$ | async"
    [environment]="environment"
    [TimeCards]="TimeCards"
    [Tasks]="tasks$ | async"
    [ServiceItems]="serviceItems$ | async"
    [documentation]="documentation$ | async"
    [AddDocumentation$]="AddDocumentation$"
    [ClassList]="this.timecardClassDataService.entities$ | async"
    [validating]="validating"
    [approving]="approving"
    [userInfo]="userInfo$ | async"
    [selectedError]="selectedError$ | async"
    [showDocumentation]="showDocumentation"
    (Close)="onClose()"
    (Save)="onSave($event)"
    (ShowError)="onShowError($event)"
    (Delete)="onDelete($event)"
    (DeleteAttachment)="onDeleteAttachment($event)"
    (UploadAttachment)="onUploadAttachment($event)"
></ef-time-card-documentation-presenter>

<p-confirmDialog></p-confirmDialog>
